// B1863: the heading of the Home page and the crumb of the Monitor page.
// This module imports nothing, so a bun test can load it without a DOM.
//
// The crumbs follow the sidebar groups (components/chrome.jsx), as the Admin
// pages do. The console has no environment name, so the crumb shows none.

export const HOME_CRUMB = 'Workspace · Home';
export const MONITOR_CRUMB = 'Workspace · Monitor';

// A server without login has no session user (owner ruling 2026-10-08).
// The page then shows this text. It never shows a fixed or guessed name.
const NO_NAME = 'unknown user';

// greetingWord returns the greeting for the local hour of `date`.
// 05:00-11:59 is morning, 12:00-17:59 is afternoon, and other hours are evening.
export function greetingWord(date) {
  const h = date.getHours();
  if (h >= 5 && h < 12) return 'Good morning';
  if (h >= 12 && h < 18) return 'Good afternoon';
  return 'Good evening';
}

// homeHeading returns the crumb and the title of the Home page.
export function homeHeading({ username, now }) {
  const name = typeof username === 'string' && username !== '' ? username : NO_NAME;
  return { crumb: HOME_CRUMB, title: `${greetingWord(now)}, ${name}` };
}
